import { Box, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { type LangType, monthYear } from '../../helpers/date';
import type { MessageNamespaces } from '../../shared/types';
import { Dash, DashList } from './dash_list';
import { useLocale, useTranslations } from './intl';

export interface DutiesProps {
  namespace: MessageNamespaces;
  duties: number;
  start: string;
  end: string;
}

export const Duties: FC<DutiesProps> = ({ namespace, duties, start, end }) => {
  const t = useTranslations();
  const locale = useLocale() as LangType;

  return (
    <Box>
      <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant="h6">{t(`${namespace}.name`)}</Typography>
        {monthYear(start, { locale })} - {end === 'now' ? t('date.now') : monthYear(end, { locale })}
      </Stack>
      <DashList>
        {Array.from({ length: duties }, (_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: needed
          <Dash key={i}>{t(`${namespace}.list.item${i + 1}`)}</Dash>
        ))}
      </DashList>
    </Box>
  );
};
